import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const SingleUserIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ height = 12, width = 12, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 8 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M1.5 9V8.11111C1.5 7.63961 1.6873 7.18743 2.0207 6.85403C2.3541 6.52063 2.80628 6.33333 3.27778 6.33333H5.05556C5.52705 6.33333 5.97924 6.52063 6.31263 6.85403C6.64603 7.18743 6.83333 7.63961 6.83333 8.11111V9M2.38889 2.77778C2.38889 3.24927 2.57619 3.70146 2.90959 4.03486C3.24299 4.36825 3.69517 4.55556 4.16667 4.55556C4.63816 4.55556 5.09035 4.36825 5.42375 4.03486C5.75714 3.70146 5.94445 3.24927 5.94445 2.77778C5.94445 2.30628 5.75714 1.8541 5.42375 1.5207C5.09035 1.1873 4.63816 1 4.16667 1C3.69517 1 3.24299 1.1873 2.90959 1.5207C2.57619 1.8541 2.38889 2.30628 2.38889 2.77778Z"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
